import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Column, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { SOMETHING_ELSE_OPTION_ID } from '../../AgentDraftingPane.utils';
import { PromptBubble } from '../../shared/PromptBubble/PromptBubble';
import { hierarchyUserBubble, isFullApply, listSelectMultiUserBubble, listSelectUserBubble, numberedListUserBubble, recapQuestion, summaryItemsUserBubble, userActionOf } from './collapseCopy';
import styles from './CollapsedRecap.module.scss';
export const GetCollapsedRecapTID = (parentTestId)=>getTestIds(parentTestId);
const isSomethingElsePrompt = (cardContent, action)=>{
    if (action == null || action.kind !== 'prompt') return false;
    if (cardContent.type !== 'numbered-list') return false;
    return cardContent.options.some((option)=>option.id === SOMETHING_ELSE_OPTION_ID && option.label === action.text);
};
const computeRecapShape = (cardContent, action, copy)=>{
    if (action == null) return {
        showQuestion: false,
        userBubble: null
    };
    if (action.kind === 'prompt') {
        if (isSomethingElsePrompt(cardContent, action)) {
            return {
                showQuestion: true,
                userBubble: action.text
            };
        }
        return {
            showQuestion: true,
            userBubble: null
        };
    }
    if (action.kind === 'dismiss') {
        return {
            showQuestion: true,
            userBubble: null
        };
    }
    if (cardContent.type === 'simple-confirmation') {
        return {
            showQuestion: false,
            userBubble: null
        };
    }
    if (cardContent.type === 'list-select') {
        return {
            showQuestion: true,
            userBubble: listSelectUserBubble(cardContent, action.selectedItemIds)
        };
    }
    if (cardContent.type === 'numbered-list') {
        return {
            showQuestion: true,
            userBubble: numberedListUserBubble(cardContent, action.selectedItemIds)
        };
    }
    if (isFullApply(cardContent, action.selectedItemIds)) {
        return {
            showQuestion: false,
            userBubble: null
        };
    }
    if (cardContent.type === 'confirmation-summary') {
        return {
            showQuestion: true,
            userBubble: summaryItemsUserBubble(cardContent.items, action.selectedItemIds, copy)
        };
    }
    if (cardContent.type === 'confirmation-hierarchy') {
        return {
            showQuestion: true,
            userBubble: hierarchyUserBubble(cardContent.sections, action.selectedItemIds, copy)
        };
    }
    if (cardContent.type === 'list-select-multi') {
        return {
            showQuestion: true,
            userBubble: listSelectMultiUserBubble(cardContent, action.selectedItemIds, copy)
        };
    }
    return {
        showQuestion: false,
        userBubble: null
    };
};
export const CollapsedRecap = (param)=>{
    let { card, userAction, justResolved, testId } = param;
    const { CollapsedRecapTID } = useMemo(()=>GetCollapsedRecapTID(testId !== null && testId !== void 0 ? testId : card.id), [
        testId,
        card.id
    ]);
    const { t } = useLocaleKeys();
    const copy = useMemo(()=>({
            none: t.agenticDrafting.userBubbles.addOnlyNone(),
            addOnly: (parts)=>t.agenticDrafting.userBubbles.addOnly({
                    parts
                }),
            hierarchySectionPart: (count, title)=>t.agenticDrafting.userBubbles.hierarchySectionPart({
                    count,
                    title
                })
        }), [
        t
    ]);
    const action = userActionOf(userAction);
    const { showQuestion, userBubble } = computeRecapShape(card.content, action, copy);
    if (!showQuestion && userBubble == null) return null;
    return /*#__PURE__*/ _jsxs(Column, {
        testId: CollapsedRecapTID.Root(),
        gap: 12,
        className: cn(styles.root, {
            [styles.justResolvedEnter]: justResolved
        }),
        children: [
            showQuestion && /*#__PURE__*/ _jsx(Typography, {
                testId: CollapsedRecapTID.Question(),
                showWhiteSpaces: true,
                children: recapQuestion(card.content)
            }),
            userBubble != null && /*#__PURE__*/ _jsx(Row, {
                justifyContent: "end",
                className: justResolved ? styles.justResolvedBubbleSlide : undefined,
                children: /*#__PURE__*/ _jsx(PromptBubble, {
                    testId: CollapsedRecapTID.UserBubble(),
                    children: userBubble
                })
            })
        ]
    });
};
